import { appointmentConstants } from '../constants/appointmentConstants';

const initialState = {
  appointments: [],
};

export default function appointment(state = initialState, action) {
  switch (action.type) {
    case appointmentConstants.GET_APPOINTMENT_DONE_REQUEST:
      return {
        ...state,
        requestingAppointment: true,
        doneAppointment: false,
      };
    case appointmentConstants.GET_APPOINTMENT_DONE_SUCCESS:
      return {
        ...state,
        requesting: false,
        doneAppointment: true,
      };
    case appointmentConstants.GET_APPOINTMENT_DONE_FAILURE:
      return {
        ...state,
        requesting: false,
        doneAppointment: false,
      };
    case appointmentConstants.GET_APPOINTMENT_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case appointmentConstants.GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        requesting: false,
        appointments: action.appointments,
      };
    case appointmentConstants.GET_APPOINTMENT_FAILURE:
      return {
        ...state,
        requesting: false,
      };
    case appointmentConstants.SET_REGISTRANT_STATUS_REQUEST:
      return {
        ...state,
        requestingAppointment: true,
        set: false,
      };
    case appointmentConstants.SET_REGISTRANT_STATUS_SUCCESS:
      return {
        ...state,
        requestingAppointment: false,
        set: true,
      };
    case appointmentConstants.SET_REGISTRANT_STATUS_FAILURE:
      return {
        ...state,
        requestingAppointment: false,
        set: false,
      };
    case appointmentConstants.DELETE_REGISTRANT_REQUEST:
      return {
        ...state,
        requestingDelete: true,
        deleted: false,
      };
    case appointmentConstants.DELETE_REGISTRANT_SUCCESS:
      return {
        ...state,
        requestingDelete: false,
        deletedAppointment: true,
      };
    case appointmentConstants.DELETE_REGISTRANT_FAILURE:
      return {
        ...state,
        requestingDelete: false,
        deletedAppointment: false,
      };
    case appointmentConstants.DELETE_APPOINTMENTS_REQUEST:
      return {
        ...state,
        requestingDelete: true,
        deletedAppointment: false,
      };
    case appointmentConstants.DELETE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        requestingDelete: false,
        deleted: true,
      };
    case appointmentConstants.DELETE_APPOINTMENTS_FAILURE:
      return {
        ...state,
        requestingDelete: false,
        deleted: false,
      };
    case appointmentConstants.CREATE_APPOINTMENT_REQUEST:
      return {
        ...state,
        requestingCreation: true,
        createdAppointment: false,
      };
    case appointmentConstants.CREATE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        requestingCreation: false,
        createdAppointment: true,
      };
    case appointmentConstants.CREATE_APPOINTMENT_FAILURE:
      return {
        ...state,
        requestingCreation: false,
        createdAppointment: false,
      };
    default:
      return state;
  }
}
